// extracted by mini-css-extract-plugin
export default {"productGallery":"kK-z","inQuickShop":"lK-z"};